import { ProjectLevel, ProjectState } from '../typings/types'

export const filterProjects = (data: any, state?: ProjectState, level?: ProjectLevel) => {
  if (data && state && level) {
    return data.filter(item => item.state === state && item.projectLevel === level)
  }
  if (data && state) {
    return data.filter(item => item.state === state)
  }
  if (data && level) {
    return data.filter(item => item.projectLevel === level)
  }
  return []
}

export const filterProjectsByState = (data: any, state: ProjectState) => {
  if (data && state) {
    return data.filter(
      item =>
        item.state === state &&
        item.projectLevel !== ProjectLevel.PRE_PAY_PACKAGE &&
        item.projectLevel !== ProjectLevel.TEMPLATES
    )
  }
  return []
}

export const allVideoProjects = (data: any) => {
  if (data) {
    return data.filter(
      item =>
        item.projectLevel !== ProjectLevel.PRE_PAY_PACKAGE &&
        item.projectLevel !== ProjectLevel.TEMPLATES
    )
  }
  return []
}
export const filterByState = (data: any, state?: ProjectState) => {
  if (data) {
    return data.filter(item => item.state === state)
  }
  return []
}



// WEBPACK FOOTER //
// ./src/helpers/filterProjects.ts